var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"dashboard","fluid":"","tag":"section"}},[_c('base-v-component',{attrs:{"heading":"SunFlight - Dashboard","link":"components/forms"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }